export * from "./types";
export { defaultPresets } from "./presets";
import { addAddressPadding } from "starknet";
import { connectToChild, } from "@cartridge/penpal";
import DeviceAccount from "./device";
import { ResponseCodes, } from "./types";
import { createModal } from "./modal";
import { defaultPresets } from "./presets";
import { NotReadyToConnect } from "./errors";
import { KEYCHAIN_URL, RPC_SEPOLIA } from "./constants";
class Controller {
    constructor(policies = [], options = {}) {
        this.url = new URL(options?.url || KEYCHAIN_URL);
        this.rpc = new URL(options?.rpc || RPC_SEPOLIA);
        this.paymaster = options.paymaster;
        this.policies = policies.map((policy) => ({
            ...policy,
            target: addAddressPadding(policy.target),
        }));
        this.setTheme(options?.theme, options?.config?.presets);
        if (options?.colorMode) {
            this.setColorMode(options.colorMode);
        }
        this.initModal();
    }
    initModal() {
        if (typeof document === "undefined")
            return;
        this.modal = createModal(this.url.toString(), () => this.keychain?.reset());
        const appendModal = () => document.body.appendChild(this.modal.element);
        if (document.readyState === "complete" ||
            document.readyState === "interactive") {
            appendModal();
        }
        else {
            document.addEventListener("DOMContentLoaded", appendModal);
        }
        this.connection = connectToChild({
            iframe: this.modal.element.children[0],
            methods: { close: () => this.modal?.close() },
        });
        this.connection.promise.then((keychain) => {
            this.keychain = keychain;
            return this.probe();
        });
    }
    setTheme(id = "cartridge", presets = defaultPresets) {
        const theme = presets[id] ?? defaultPresets.cartridge;
        this.url.searchParams.set("theme", encodeURIComponent(JSON.stringify(theme)));
    }
    setColorMode(colorMode) {
        this.url.searchParams.set("colorMode", colorMode);
    }
    ready() {
        return (this.connection?.promise
            .then(() => this.probe())
            .then((res) => !!res, () => false) ?? Promise.resolve(false));
    }
    async probe() {
        if (!this.keychain || !this.modal) {
            console.error(new NotReadyToConnect().message);
            return null;
        }
        try {
            const res = await this.keychain.probe();
            if (res.code !== ResponseCodes.SUCCESS) {
                return;
            }
            const { address } = res;
            this.account = new DeviceAccount(this.rpc.toString(), address, this.keychain, this.modal, this.paymaster);
        }
        catch (e) {
            console.error(e);
            return;
        }
        return !!this.account;
    }
    async connect() {
        if (this.account) {
            return this.account;
        }
        if (!this.keychain || !this.modal) {
            console.error(new NotReadyToConnect().message);
            return;
        }
        if (!!document.hasStorageAccess) {
            const ok = await document.hasStorageAccess();
            if (!ok) {
                await document.requestStorageAccess();
            }
        }
        this.modal.open();
        try {
            let response = await this.keychain.connect(this.policies, this.rpc.toString());
            if (response.code !== ResponseCodes.SUCCESS) {
                throw new Error(response.message);
            }
            response = response;
            this.account = new DeviceAccount(this.rpc.toString(), response.address, this.keychain, this.modal, this.paymaster);
            return this.account;
        }
        catch (e) {
            console.log(e);
        }
        finally {
            this.modal.close();
        }
    }
    async disconnect() {
        if (!this.keychain) {
            console.error(new NotReadyToConnect().message);
            return;
        }
        if (!!document.hasStorageAccess) {
            const ok = await document.hasStorageAccess();
            if (!ok) {
                await document.requestStorageAccess();
            }
        }
        this.account = undefined;
        return this.keychain.disconnect();
    }
    revoke(origin, _policy) {
        if (!this.keychain) {
            console.error(new NotReadyToConnect().message);
            return null;
        }
        return this.keychain.revoke(origin);
    }
    username() {
        if (!this.keychain) {
            console.error(new NotReadyToConnect().message);
            return;
        }
        return this.keychain.username();
    }
}
export * from "./types";
export * from "./errors";
export default Controller;
//# sourceMappingURL=index.js.map